import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=71c12a0a&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c12a0a",
  null
  
)

export default component.exports